<template>
	<!-- 판매내역 테이블 시작 -->
	<!-- 테이블 컨텐츠 -->
	<ul class="table" v-if="dealList.length > 0">
		<li v-for="item in dealList" :key="item.seq">
			<div class="list_item border_b_gray1">
				<span class="list_num_m">{{ item._no }}</span>
				<div class="status_area item">
					<p class="fs_14">
						{{ $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
					</p>
					<div
						:class="['status ' + item.status, 'd_flex', 'align_items_center']"
					>
						<span class="icon"></span>
						<span>{{ $t('c2c.' + item.status) }}</span>
					</div>
				</div>
				<div class="d_flex mb_8">
					<div class="item mr_16">
						<p>{{ $t('rtr_activity-c2c.sold_asset') }}</p>
						<div class="asset_box">
							<span :class="[item.source_asset_code, 'small']"></span>
							<p class="code mr_4">{{ item.source_asset_code }}</p>
							<p class="name">{{ item.source_asset_title }}</p>
						</div>
					</div>
					<div class="item">
						<p>{{ $t('rtr_activity-c2c.payment_asset') }}</p>
						<div class="asset_box">
							<span :class="[item.target_asset_code, 'small']"></span>
							<p class="code mr_4">{{ item.target_asset_code }}</p>
							<p class="name">{{ item.target_asset_title }}</p>
						</div>
					</div>
				</div>
				<div class="item mb_4">
					<p>{{ $t('rtr_activity-c2c.registered_quantity') }}</p>
					<div class="num_unit type01">
						<p class="num">{{ item.source_amount }}</p>
						<p class="unit">{{ item.source_asset_code }}</p>
					</div>
				</div>
				<div class="item">
					<p>{{ $t('rtr_activity-c2c.sold_price') }}</p>
					<p>
						{{ item.min_price }}
						<span class="fs_12"> {{ item.target_asset_code }}</span>
					</p>
				</div>
				<div class="btn_area tar">
					<button
						class="button_bg_black"
						@click="$emit('showDetailList', item.seq)"
					>
						{{ $t('button.check') }}
					</button>
					<button
						v-if="item.status === 'OPEN'"
						@click="cancelDealHandler(item.seq)"
					>
						{{ $t('button.cancel') }}
					</button>
				</div>
			</div>
			<!-- 테이블 컨텐츠2 -->
			<Accordion>
				<AccordionItem2>
					<template v-slot:accordion-trigger>
						<span class="accordion_trigger_icon"></span>
					</template>
					<template v-slot:accordion-content>
						<div class="accordion_border">
							<div class="body_l">
								<div class="item mb_4">
									<p>{{ $t('rtr_activity-c2c.safety_type') }}</p>
									<p>{{ $t('c2c.escrow_type.' + item.escrow_type) }}</p>
								</div>
								<!-- <div class="item"> -->
								<div class="item mb_4">
									<p>{{ $t('rtr_activity-c2c.min_purchase_quantity') }}</p>
									<p>{{ item.source_min_amount }}</p>
								</div>
								<div class="d_flex mb_4">
									<div class="item mr_16">
										<p>{{ $t('rtr_activity-c2c.confirmed_sales_quantity') }}</p>
										<p>{{ item.confirmed_source_amount }}</p>
									</div>
									<div class="item">
										<p>
											{{ $t('rtr_activity-c2c.unconfirmed_sales_quantity') }}
										</p>
										<p>{{ item.holding_source_amount }}</p>
									</div>
								</div>
								<div class="item mb_4">
									<p>{{ $t('rtr_activity-c2c.available_quantity') }}</p>
									<p>{{ item.potential_source_amount }}</p>
								</div>
								<div class="item" v-if="item.closed_date">
									<p>{{ $t('rtr_activity-c2c.closing_date') }}</p>
									<p>
										{{ $dayjs(item.closed_date).format('YYYY.MM.DD HH:mm:ss') }}
									</p>
								</div>
								<!-- </div> -->
							</div>
						</div>
					</template>
				</AccordionItem2>
			</Accordion>
		</li>
		<pagination
			class="pb_16"
			:totalCount="pageNavigation.total_count"
			:totalPage="pageNavigation.total_page"
			:curPage="pageNavigation.cur_page"
			:point="pageNavigation.point"
			:firstPage="pageNavigation.first_page"
			:lastPage="pageNavigation.last_page"
			@change="pageChangeHandler"
		></pagination>
	</ul>
	<div class="list_none" v-else>
		<div v-if="!loading">
			<span class="ERRORGRAY"></span>
			<p>{{ $t('rtr_activity-c2c.empty2') }}</p>
		</div>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="mb_40">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'">
			<button class="button_bg_red button_m" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'">
			<button class="button_bg_red button_m" @click="cancelPrivateDeal">
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import Accordion from '@/components/Layout/Accordion.vue';
import AccordionItem2 from '@/components/Layout/AccordionItem2';
import Pagination from '@/components/Pagination';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import { cancelPrivateDeal, fetchPrivateDeals } from '@/api/deal';
import { commonError } from '@/common/dialog';
export default {
	name: 'Sale.m',
	emits: ['showDetailList'],
	components: {
		Pagination,
		Accordion,
		AccordionItem2,
		ModalMessageM,
	},
	props: ['startDate', 'endDate', 'assetSeq'],
	data() {
		return {
			dealList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			dealSeq: null,
			loading: false,
		};
	},
	watch: {
		startDate() {
			this.curPage = 1;
			this.loadDealList();
		},
		endDate() {
			this.curPage = 1;
			this.loadDealList();
		},
		assetSeq() {
			this.curPage = 1;
			this.loadDealList();
		},
	},
	mounted() {
		this.init();
	},
	methods: {
		init() {
			this.loadDealList();
		},
		async loadDealList() {
			this.loading = true;
			const params = {
				regdate_start: this.$dayjs(new Date(this.startDate))
					.startOf('day')
					.valueOf(),
				regdate_end: this.$dayjs(this.endDate).endOf('day').valueOf(),
				page: this.curPage,
				list_count: this.listCount,
				source_asset_seq: this.assetSeq,
				own_deals: 1,
			};
			const { data, page_navigation } = await fetchPrivateDeals(params).catch(
				commonError,
			);
			this.loading = false;
			this.dealList = data;
			this.pageNavigation = page_navigation;
		},
		cancelDealHandler(dealSeq) {
			this.dealSeq = dealSeq;
			this.modalIcon = 'information';
			this.modalStatusMessage = this.$t('modal.message.set_cancel');
			this.messageModalMode = 'information';
			this.messageModal = true;
		},
		async cancelPrivateDeal() {
			this.messageModal = false;
			await cancelPrivateDeal(this.dealSeq)
				.then(() => {
					this.modalIcon = 'success';
					this.modalStatusMessage = this.$t('modal.message.success_cancel');
					this.messageModalMode = 'success';
					this.messageModal = true;
					this.loadDealList();
				})
				.catch(commonError);
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadDealList();
		},
	},
};
</script>
<style scoped></style>
